//* 반복 예약 삭제 조건 설정 모달

import Modal from "react-modal";
import { Btns, CancelBtn, Container, Heading, OptionItem, Options, Section } from "./index.styles";
import UI from "@mile-meeting/mile-ui";
import { useEffect, useState } from "react";

export enum RepeatReservationConditionalOption {
  THIS_SCHEDULE = "THIS_SCHEDULE",
  THIS_SCHEDULE_AND_FUTURE_SCHEDULES = "THIS_SCHEDULE_AND_FUTURE_SCHEDULES",
  ALL_SCHEDULES = "ALL_SCHEDULES",
}

export type RepeatReservationEditConditionalModalProps = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onHandleEdit: (selectedOption: RepeatReservationConditionalOption) => void;
};

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    width: "400px",
    borderRadius: "20px",
    transform: "translate(-50%, -50%)",
    padding: 0,
    margin: 0,
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};

export default function RepeatEditConditionalModal(props: RepeatReservationEditConditionalModalProps) {
  const { modalIsOpen, closeModal, onHandleEdit } = props;
  const [selectedOption, setSelectedOption] = useState<RepeatReservationConditionalOption>(
    RepeatReservationConditionalOption.THIS_SCHEDULE
  );

  useEffect(() => {
    setSelectedOption(RepeatReservationConditionalOption.THIS_SCHEDULE);
  }, [props.modalIsOpen]);

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelBtn>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelBtn>
        <Heading>
          <UI.Typography type="heading02" fontStyle="bold" color="var(--alias-color-label-neutral)">
            반복 예약 수정 조건 설정
          </UI.Typography>
        </Heading>
        <Section>
          <Options>
            <OptionItem onClick={() => setSelectedOption(RepeatReservationConditionalOption.THIS_SCHEDULE)}>
              <UI.Radio selected={selectedOption === RepeatReservationConditionalOption.THIS_SCHEDULE} />
              <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                이 예약
              </UI.Typography>
            </OptionItem>
            <OptionItem
              onClick={() => setSelectedOption(RepeatReservationConditionalOption.THIS_SCHEDULE_AND_FUTURE_SCHEDULES)}
            >
              <UI.Radio
                selected={selectedOption === RepeatReservationConditionalOption.THIS_SCHEDULE_AND_FUTURE_SCHEDULES}
              />
              <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                이 예약 및 향후 예약
              </UI.Typography>
            </OptionItem>
            <OptionItem onClick={() => setSelectedOption(RepeatReservationConditionalOption.ALL_SCHEDULES)}>
              <UI.Radio selected={selectedOption === RepeatReservationConditionalOption.ALL_SCHEDULES} />
              <UI.Typography type="body01 normal" fontStyle="regular" color="var(--alias-color-label-normal)">
                모든 예약
              </UI.Typography>
            </OptionItem>
          </Options>
          <Btns>
            <UI.Button size="large" onClick={closeModal} title="취소하기" type="outlined" style={{ width: "100%" }} />
            <UI.Button
              size="large"
              onClick={() => onHandleEdit(selectedOption)}
              title="수정하기"
              type="solid"
              style={{ width: "100%" }}
            />
          </Btns>
        </Section>
      </Container>
    </Modal>
  );
}
